import React from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  TextField,
  Select,
  InputLabel,
  Button,
  MenuItem,
  FormControl,
  FormHelperText,
  TextareaAutosize,
} from "@mui/material";
import axios from "axios";
import { client } from "services/api";
import { useNavigate } from "react-router-dom";
import { notification } from "antd";

export default function Contact() {
  const navigate = useNavigate();

  const initialValues = {
    name: "",
    phone: "",
    type: "",
    message: "",
  };

  const validationSchema = yup.object({
    name: yup.string().required("Invalide, réessayez"),
    phone: yup
      .number("Téléphone non valide, réessayer")
      .required("Veuillez entrer un numéro de téléphone")
      .min(6, "Non valide, réessayer"),
    type: yup.string().required("Invalide"),
    message: yup
      .string()
      .required("Entrez un message !")
      .min(20, "Votre message doit comporter au moins 20 caracteres"),
  });

  const sendContact = async (payload) => {
    await client
      .post("/contact/createContact", payload)
      .then((res) => console.log(res.data));

    notification.success({ message: "Message envoyé avec succès !" });

    setTimeout(() => navigate("/"), 3000);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => sendContact(values),
  });

  return (
    <>
      <div className="w-full h-[80vh] mt-10">
        <div className="w-full  h-3/4 bg-transparent my-12 flex justify-center items-center text-[#484848] font-bold ">
          <div className="w-[60%] bg-[#eee] p-5">
            <h4 className="text-[#108758] text-2xl after:absolute after:bg-[#108758] after:w-1/18 after:h-[4px] after:block">Contactez-nous</h4>
            <h2 className="form-headline relative mb-6">
              Envoyez-nous un message quelques soit vos besoins. Nous somme disponible et disposé à vous satisfaire.
              </h2>
            <form onSubmit={formik.handleSubmit} className="h-auto">
              <div className="flex w-full justify-between mb-4">
                <div className="basis-1/2 mr-2">
                  <FormControl fullWidth>
                    <TextField
                      sx={{ background: "#FFFF" }}
                      name="name"
                      label="Nom"
                      value={formik.values.name}
                      error={Boolean(formik.errors.name) && formik.touched.name}
                      helperText={formik.errors.name && formik.touched.name}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
                <div className="basis-1/2 ml-2">
                  <FormControl fullWidth>
                    <TextField
                      sx={{ background: "#FFFF" }}
                      name="phone"
                      label="Numéro"
                      value={formik.values.phone}
                      error={
                        Boolean(formik.errors.phone) && formik.touched.phone
                      }
                      helperText={formik.errors.phone && formik.touched.phone}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>
              </div>
              <div className="mb-4">
                <FormControl
                  fullWidth
                  error={formik.touched.type && Boolean(formik.errors.type)}
                >
                  <InputLabel>Type de compte</InputLabel>
                  <Select
                    sx={{ background: "#FFFF" }}
                    name="type"
                    label="TYpe de compte"
                    value={formik.values.type}
                    onChange={formik.handleChange}
                  >
                    {[
                      { label: "Prestataire", value: "PRESTATAIRE" },
                      { label: "Conseiller", value: "CONSEILLER" },
                      { label: "Exploitant Agricole", value: "FARMER" },
                    ].map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>
                    {formik.touched.type && formik.errors.type}
                  </FormHelperText>
                </FormControl>
              </div>

              <div className="mb-4">
                <FormControl fullWidth>
                  <FormHelperText>
                    {formik.touched.message && Boolean(formik.errors.message)}
                  </FormHelperText>
                  <TextareaAutosize
                    minRows={6}
                    name="message"
                    label="Message"
                    value={formik.values.message}
                    error={
                      Boolean(formik.errors.message) && formik.touched.message
                    }
                    helperText={formik.errors.message && formik.touched.message}
                    onChange={formik.handleChange}
                  />
                </FormControl>
              </div>

              <div className="w-full flex justify-between">
              <Button
                  size="large"
                  variant="outlined"
                  disableElevation
                  color="primary"
                  type="button"
                  onClick={formik.handleReset}
                >
                  Accueil
                </Button>
              <Button
                  size="large"
                  variant="outlined"
                  disableElevation
                  color="success"
                  type="submit"
                  // onClick={() => navigate("/")}
                >
                  Annuler
                </Button>
                <Button
                  size="large"
                  variant="outlined"
                  disableElevation
                  color="success"
                  type="submit"
                  // onClick={() => navigate("/")}
                >
                  Envoyer le message
                </Button>

               
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
